import { InputTextarea } from "primereact/inputtextarea";
import ReactMarkdown from "react-markdown";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../hooks/hooks";

export const Documentation = () => {
  const documentation = useAppSelector((state) => state.editor.sidebar.arg);
  const { t } = useTranslation();
  return (
    <>
      <div className="p-3">
        <div className="mb-3">
          <b> {t("label.name")} :</b> <span className="contentList">{documentation.name}</span> 
        </div>
        <div>
          <b className="mb-3">{t("label.description")} :</b>

          <ReactMarkdown className="contentList" children={documentation.description} />
        </div>
      </div>
    </>
  );
};
